import valid from 'card-validator'

export default function validateCreditCard(value) {
  const numberValidation = valid.number(value)

  return numberValidation.isPotentiallyValid ? undefined : 'Cartão inválido.'
}
